import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

import { Comment } from '@model/Comment';

@Injectable({providedIn: 'root'})
export class CommentService {

  static projectOpened = new EventEmitter<number>();

  constructor(private http: HttpClient) {
  }

  getCountMessage(projectId: number) {
    CommentService.projectOpened.emit(projectId);
  }

  get(projectId: number, apiRoute: string): Observable<Array<Comment>> {
    return this.http.get<Array<Comment>>(`${environment.base_url}/projects/${projectId}/comments?api_route=${apiRoute}`);
  }

  getByProject(projectId: number): Observable<Array<Comment>> {
    return this.http.get<Array<Comment>>(`${environment.base_url}/projects/${projectId}/comments/comments_menu`);
  }

  store(form: Comment): Observable<Comment> {
    return this.http.post<Comment>(`${environment.base_url}/comments`, form);
  }

  update(commentId: number, form: Comment): Observable<any> {
    return this.http.put(`${environment.base_url}/comments/${commentId}`, form);
  }

  delete(commentId: number): Observable<any> {
    return this.http.delete(`${environment.base_url}/comments/${commentId}`);
  }

  count(projectId: number): Observable<number> {
    return this.http.get<number>(`${environment.base_url}/projects/${projectId}/comments/count`);
  }

  solve(commentId: number): Observable<Comment> {
    return this.http.get<Comment>(`${environment.base_url}/comments/${commentId}/solve`);
  }
}
